import React, { useEffect, useState } from 'react';
import "../AnimatedTextField/textFieldStyles.css";
import PhoneInput, { getCountryCallingCode, parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

function AnimatedPhoneInput({ label, value, handleInputChange, isMandatory, inputId, isDisabled, disabled,onKeyDown }) {
    const [countryCode, setCountryCode] = useState('+91');
    const [isFocused, setIsFocused] = useState(false);
    const isExpanded = isFocused || !!value;

    const handleCountrySelectClick = (country) => {
        if (country) {
            const callingCode = getCountryCallingCode(country);
            setCountryCode(`+${callingCode}`);
        }
    };

    useEffect(() => {
        if (value) {
            const phoneNumber = parsePhoneNumber(value);
            if (phoneNumber) {
                setCountryCode(`+${getCountryCallingCode(phoneNumber.country)}`);
            }
        }
    }, [value]);

    const phoneInputValue = value
        ? (value.startsWith('+') ? value : `${countryCode}${value}`)
        : (isFocused ? countryCode : undefined);


    return (
        <div className={`custom-input-container custom-phone-input-container m-t-20 ${isExpanded ? 'expanded' : ''}`}>
            <label
                htmlFor={`customInput_${inputId}`}
                id={`customInputLabel_${inputId}`}
                className={`custom-input-label ${isExpanded ? 'shrink' : ''}`}
            >
                {label} {isMandatory ? <span style={{ color: 'red' }}>*</span> : null}
            </label>

            <PhoneInput
                id={`customInput_${inputId}`}
                className="custom-phone-input-enquiry"
                onKeyDown={onKeyDown ? onKeyDown : (e) => {
                    if (e.key.toLowerCase() === 'e' || e.keyCode === 69) {
                        e.preventDefault();
                    }
                }}
                onChange={(val) => {
                    handleInputChange(val);
                }}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                maxLength={16}
                limitMaxLength={true}
                defaultCountry="IN"
                addInternationalOption={true}
                disabled={disabled}
                value={phoneInputValue}
                onCountryChange={handleCountrySelectClick}
            />
        </div>
    );
}

export default AnimatedPhoneInput;
